export default __webpack_public_path__ + "static/media/clock.54e9792c.svg";